import type { OfferFragment } from '@occc/graphql';
import type { ScanDataConfigurationFormValues } from '@occc/validation';

export type ScanDataConfigurationFormSlice = {
  scanDataConfiguration: ScanDataConfigurationFormValues;
};

export const transformOfferScanDataConfigurationToInitialValues = (
  scanDataConfiguration: OfferFragment['scanDataConfiguration'],
): ScanDataConfigurationFormSlice => {
  if (!scanDataConfiguration) {
    return {
      scanDataConfiguration: {
        isEnabled: false,
        fundingSource: '',
        description: '',
        discountAllocation: undefined,
      },
    };
  }

  return {
    scanDataConfiguration: {
      isEnabled: true,
      fundingSource: scanDataConfiguration.fundingSource,
      description: scanDataConfiguration.description,
      // API returns pennies (Int!); form displays dollars
      discountAllocation: scanDataConfiguration.discountAllocation / 100,
    },
  };
};
